export default "__VITE_ASSET__DPvrg5oQ__$_?component__"